module.exports = __webpack_public_path__ + "static/media/veneto-3-06.82fe35db.jpg";